<template>
  <div class="page main-signin-wrapper bg-signin">
    <div class="row signpages text-center">
      <div class="col-md-12 my-auto">
        <div class="card">
          <div class="row row-sm m-0">
            <!-- Panel izquierdo: logo (solo pantallas >= lg) -->
            <div class="col-lg-6 col-xl-5 d-none d-lg-block text-center details">
              <div class="position-absolute top-50 start-50 translate-middle logo-wrap">
                <img
                  :src="require('@/assets/img/pages/authentication/desktop-white.png')"
                  class="header-brand-img mw-40"
                  alt="logo"
                >
              </div>
            </div>

            <!-- Panel derecho: formulario -->
            <div class="col-lg-6 col-xl-7 col-xs-12 col-sm-12 login_form">
              <div class="main-container container-fluid">
                <div class="row row-sm">
                  <div class="card-body mt-2 mb-2">
                    <h5 class="text-start mb-2">
                      Olvidó su contraseña
                    </h5>
                    <p class="mb-4 text-muted fs-13 ms-0 text-start">
                      Recuperar tu cuenta tomará solo unos minutos.
                    </p>
                    <form @submit.prevent="onForgotPassword">
                      <div class="form-group text-start">
                        <label for="forgotEmail">Correo</label>
                        <input
                          id="forgotEmail"
                          v-model="email"
                          class="form-control"
                          placeholder="Introduce tu correo"
                          type="text"
                        >
                        <button
                          type="submit"
                          class="btn ripple btn-primary w-100 mt-2"
                          :disabled="processing"
                        >
                          <b-spinner
                            v-if="processing"
                            small
                            type="grow"
                            class="mr-2"
                          />
                          Solicitar una nueva contraseña
                        </button>
                      </div>
                    </form>

                    <div class="card-footer border-top-0 ps-0 mt-3 text-start">
                      <p>¿Recordaste tu contraseña?</p>
                      <p class="mb-0">
                        Intenta
                        <router-link :to="{ name: 'login' }">
                          Iniciar sesión
                        </router-link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

const COLABORADORES_API_URL = process.env.VUE_APP_COLABORADORES_URL
const FORGOT_PASSWORD_PATH = 'user/forgot_my_password'

export default {
  name: 'ForgotPassword',
  data() {
    return {
      email: '',
      processing: false,
    }
  },
  methods: {
    async onForgotPassword() {
      if (!this.email) {
        this.$bvToast.toast('Ingresa tu correo para continuar', {
          title: 'Error',
          variant: 'danger',
          solid: false,
        })
        return
      }

      this.processing = true
      try {
        await axios.put(
          `${COLABORADORES_API_URL}${FORGOT_PASSWORD_PATH}`,
          {},
          {
            params: { email: this.email },
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
          },
        )
        this.$bvToast.toast(
          'Te enviamos una nueva contraseña a tu correo.',
          {
            title: 'Éxito',
            variant: 'success',
            solid: false,
          },
        )
        this.email = ''
      } catch (error) {
        const notFound = error?.response?.status === 404
          || error?.response?.data?.detail?.toLowerCase().includes('user not found')
        this.$bvToast.toast(
          notFound
            ? 'No encontramos una cuenta con ese correo.'
            : 'No fue posible procesar la solicitud, intentalo nuevamente.',
          {
            title: 'Error',
            variant: 'danger',
            solid: false,
          },
        )
      } finally {
        this.processing = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$primary-prod: rgb(20, 108, 253);
$border-prod: #e9edf6;
$card-border-prod: #e8e8f7;
$muted-prod: #8f8fb1;
$text-prod: #1d212f;

/* Utilidades de Bootstrap 5 / tema Link que no existen en Bootstrap 4 */
.text-start {
  text-align: left !important;
}

.fs-13 {
  font-size: 0.8125rem !important;
}

.ms-0 {
  margin-left: 0 !important;
}

/* La escala de espaciado del tema de Inspector difiere de Bootstrap 5 de Link */
.mb-4 {
  margin-bottom: 24px !important;
}

.mt-2 {
  margin-top: 8px !important;
}

.mt-3 {
  margin-top: 16px !important;
}

.mb-2 {
  margin-bottom: 8px !important;
}

.rounded-2 {
  border-radius: 6px !important;
}

.top-50 {
  top: 50% !important;
}

.start-50 {
  left: 50% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.page.main-signin-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: 'Gotham Rounded Light', 'sans-serif';

  .signpages {
    border-radius: 6px;
    width: 50%;
    margin: 5em auto;
    display: flex;

    @media (max-width: 1299.98px) {
      width: 60%;
    }

    @media (max-width: 640px) {
      width: 90%;
    }

    > .col-md-12 {
      padding-left: 12px;
      padding-right: 12px;
    }

    .card {
      width: 100%;
      border: 1px solid $card-border-prod;
      border-radius: 6px;
      background-color: #fff;
      box-shadow: none;

      .row.row-sm {
        margin-left: -10px;
        margin-right: -10px;

        > [class*='col-'] {
          padding-left: 10px !important;
          padding-right: 10px !important;
        }
      }

      .details {
        position: relative;
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
        background-color: $primary-prod;
        overflow: hidden;

        .logo-wrap {
          width: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .header-brand-img {
          width: 100%;
          max-width: 100%;
          height: auto;
        }
      }

      .login_form {
        background-color: #fff;
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;

        .main-container {
          width: 100%;
          padding: 0 12px;
        }

        .card-body {
          display: flex;
          flex-direction: column;
          gap: 8px;
          padding: 1.5rem 10px;
        }

        h5 {
          font-size: 17.5px;
          font-weight: 500;
          font-family: 'Gotham Rounded Light', 'sans-serif';
          line-height: 1.2;
          color: $text-prod;
          margin-bottom: 8px;
          text-align: left;
        }

        p {
          font-size: 13px;
          line-height: 1.5;
          color: $muted-prod;
          margin-bottom: 24px;
          text-align: left;
        }

        .form-group {
          margin-bottom: 16px;
          text-align: left;

          label {
            font-size: 14px;
            color: $text-prod;
            margin-bottom: 0;
          }

          .form-control {
            height: 38.5px;
            padding: 6px 12px;
            font-size: 14px;
            line-height: 1.75;
            color: $muted-prod;
            background-color: #fff;
            border: 1px solid $border-prod;
            border-radius: 5.6px;

            &:focus {
              color: $text-prod;
              border-color: #86b7fe;
              box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
            }

            &::placeholder {
              color: $muted-prod;
            }
          }
        }

        .ripple {
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .btn-primary {
          height: 40px;
          padding: 8px 13.6px;
          font-size: 13.6px;
          line-height: 20.4px;
          background-color: $primary-prod !important;
          border-color: $primary-prod !important;
          color: #fff !important;
          border-radius: 3px;

          &:hover:not(:disabled) {
            background-color: rgba(20, 108, 253, 0.9) !important;
            border-color: $primary-prod !important;
          }
        }

        .card-footer {
          background-color: transparent;

          p {
            margin-bottom: 4px;
          }

          a {
            color: $primary-prod;
            text-decoration: none;
          }
        }
      }
    }
  }
}

.bg-signin {
  background-image: url("~@/assets/img/pages/authentication/background-signin.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}
</style>
